module.exports = __webpack_public_path__ + "img/banner-escritorio.1ca5413d.jpg";